@if(hasDocuments()) {
  <div class="flex-container">
    <button mat-flat-button color="accent" class="right-icon-button"
      [attr.aria-label]="'common.labels.downloadResultDocument' | transloco" data-testid="result-document-button" [matMenuTriggerFor]="downloadMenu">
      <mat-icon aria-hidden="false" [attr.aria-label]="'common.labels.downloadIcon' | transloco">
        keyboard_arrow_down
      </mat-icon>
      <mat-label>{{ 'downloadBatchDocuments.documents' | transloco }}</mat-label>
    </button>

    <mat-menu #downloadMenu="matMenu">
      @if (hasBatchDocument()) {
        <button mat-menu-item (click)="downloadDocument($safeNavigationMigration(this.batch.rawDocument?.id))">
          <mat-icon color="primary">download</mat-icon>
          <span class="primary">{{ 'downloadBatchDocuments.batchCsv' | transloco }}</span>
        </button>
      }

      @if (hasNormalizedBatchDocument()) {
        <button mat-menu-item (click)="downloadDocument($safeNavigationMigration(this.batch.normalizedDocument?.id))">
          <mat-icon color="primary">download</mat-icon>
          <span class="primary">{{ 'downloadBatchDocuments.normalizedBatchCsv' | transloco }}</span>
        </button>
      }

      @if (hasBatchResultDocument()) {
        <button mat-menu-item (click)="downloadDocument($safeNavigationMigration(this.batch.batchResultDocument?.id))">
          <mat-icon color="primary">download</mat-icon>
          <span class="primary">{{batchResultLabel()}}</span>
        </button>
      }

      @if (hasRegistryDocuments()) {
        <button mat-menu-item (click)="downloadDocument($safeNavigationMigration(this.batch.orderResultsDocument?.id))">
          <mat-icon color="primary">download</mat-icon>
          <span class="primary">{{ 'downloadBatchDocuments.registryDocuments' | transloco }}</span>
        </button>
      }

      @if (hasRegHubDocuments()) {
        <button mat-menu-item (click)="downloadDocument($safeNavigationMigration(this.batch.orderSummariesDocument?.id))">
          <mat-icon color="primary">download</mat-icon>
          <span class="primary">{{regHubDocumentLabel()}}</span>
        </button>
      }
    </mat-menu>
  </div>
}
